import { useFischer } from 'composables/fischerPlugin';

export const getSellingUnitsArray = () => {
  const fischer = useFischer();
  const { sellingUnits } = fischer.shopSettings();
  const sellingUnitsObject =
    typeof sellingUnits === 'object' ? Object.values(sellingUnits) : sellingUnits;

  return sellingUnitsObject;
};

export const getSellingUnit = (code: string) => {
  const sellingUnits = getSellingUnitsArray();

  if (sellingUnits) {
    const sellingUnit = sellingUnits.find((el: any) => el?.Code === code);

    if (sellingUnit?.Name_Short) {
      return sellingUnit.Name_Short;
    }
  }

  return code;
};

export const getSellingUnitInString = (unitString: string) => {
  let formattedUnitString = unitString;

  const sellingUnits = getSellingUnitsArray();
  if (sellingUnits) {
    sellingUnits.forEach((unit: any) => {
      if (!(unit?.Code && unit.Name_Short)) {
        return;
      }
      const reg = new RegExp(`\\b${unit.Code}\\b`);
      if (reg.test(formattedUnitString)) {
        formattedUnitString = unitString.replace(unit.Code, unit.Name_Short);
      }
    });
  }

  return formattedUnitString;
};
